export default __webpack_public_path__ + "images/x-circle-12.svg";